"use client"

import Link from "next/link"
import { ResponsiveHeader } from "@/components/responsive-header"

export function ConsultHeader() {
  return (
    <>
      <ResponsiveHeader />
      <div style={{ borderBottom: "1px solid var(--border-soft)", background: "var(--bg-soft)" }}>
        <div className="font-mono" style={{ maxWidth: 1240, margin: "0 auto", padding: "10px 48px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap", fontSize: 11 }}>
          <span style={{ color: "var(--text-2)" }}>Need help choosing the right HSVE service?</span>
          <span style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
            <Link href="/contact" style={{ color: "var(--accent)", textDecoration: "none" }}>discuss project</Link>
            <Link href="/vmware-to-proxmox" style={{ color: "var(--text-2)", textDecoration: "none" }}>VMware migration</Link>
            <Link href="/templates" style={{ color: "var(--text-2)", textDecoration: "none" }}>templates</Link>
            <a href="https://docs.hsve.cc" target="_blank" rel="noopener noreferrer" style={{ color: "var(--text-2)", textDecoration: "none" }}>docs</a>
          </span>
        </div>
      </div>
    </>
  )
}
